import './utils/isMobile';
import React from 'react';
import { Provider } from 'mobx-react';
import 'antd/dist/antd.less';
import store from '@/models/index';
import { configure } from 'mobx';
import { initScout, initSvgIcons } from './utils/common';

configure({
  enforceActions: 'never',
});
initSvgIcons();
initScout()
/**
 * 修改交给 react-dom 渲染时的根组件
 * 比如用于在外面包一个 Provider；
 * @param container
 * @param params
 */
export const rootContainer = (container: React.ElementType) => {
  return <Provider store={store}>{container}</Provider>;
};
